<div fxLayout="column" fxLayoutAlign="center center">
  <div fxLayout="column" fxFlex="100" class="container partners" fxLayoutGap="48px">
    <div fxLayout="row" fxLayoutGap="20px">
      <div fxLayout="column" fxLayoutGap="20px">
        <h2>ReSupply partners with 400+ insured and contracted hauling companies</h2>
        <p>
          When you schedule a pickup, our contracted team of licensed and insured professional haulers will take care of everything. These
          small businesses have the training, tools, and equipment to remove even the heaviest and largest of donations. They specialize in
          moving quickly and efficiently to protect charity staff from the physically demanding job of donation removal.
        </p>
      </div>
      @if (!isSmallWindowSize) {
        <img class="img1" src="/assets/split-screen-v3/partners1.webp" />
      }
    </div>
    <div fxLayout="row" fxLayout.lt-md="column-reverse" fxLayoutGap="20px" fxLayoutGap.lt-lg="48px">
      <img class="img2" src="/assets/split-screen-v3/partners2.webp" />
      <div fxLayout="column" fxFlex fxLayoutAlign="center center" fxLayoutAlign.lt-md="start start">
        <div fxLayout="column" style="width: 80%" fxLayoutAlign="start start" fxLayoutGap="20px">
          <div>
            <h3>25,000+</h3>
            <p>Zip codes covered</p>
          </div>
          <div>
            <h3>500+</h3>
            <p>Trucks</p>
          </div>
        </div>
      </div>
    </div>
    <div fxLayout="column" fxLayoutAlign="center center" fxFlex>
      <button fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" class="primary" (click)="goToPrimary(sectionType)">
        <span fxFlex="100">Continue to donation{{ !isSmallWindowSize ? ' pickup' : '' }}</span>
        <mat-icon svgIcon="ss3-arrow-right" />
      </button>
    </div>
  </div>
</div>
